import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
import { IoChevronBack } from 'react-icons/io5';
import LoadingOverlay from '../components/LoadingOverlay';
import { useNoobookContext } from '../context/NoobookContext';
import { getMyBookByBookId, getMyBookMemos, putMyBookReadDone } from '../api/BookcaseApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getDday, stringFrDate } from '../common/utils';
import { ownership2text } from '../common/enums';
import { ErrorContainer, ErrorMessage } from '../components/ErrorContainer';
import BookRegisterPage from './BookRegisterPage';
import { FaTimes } from 'react-icons/fa';
import BookTimerPage from './BookTimerPage';
import BookRecordPage from './BookRecordPage';
import BookCoverImage from '../components/BookCoverImage';

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
`;

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #eae8e9;
`;

const RoundedDarkBox = styled.div`
  background: #393939;
  border-radius: 24px 24px 0 0;
  margin-top: 0;
  padding: 12px 12px 100px 12px;
`;

const SeparatorBar = styled.div`
  width: 100%;
  max-width: 440px;
  height: 12px;
  background: #eae8e9;
  border-radius: 4px;
  border-top: 1px solid #fff;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  margin: -18px auto 32px auto;
`;

const ProgressBox = styled.div`
  background: #fff;
  border-radius: 18px;
  margin: 0 auto;
  max-width: 420px;
  padding: 24px 20px 20px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const ProgressLabel = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ProgressLabelLeft = styled.div`
  display: flex;
  align-items: center;
`;

const ProgressBarWrap = styled.div`
  width: 100%;
  background: #eee;
  border-radius: 8px;
  height: 12px;
  margin-bottom: 6px;
`;

const ProgressBar = styled.div`
  width: ${props => props.percent}%;
  background: #1ed760;
  height: 100%;
  border-radius: 8px;
  transition: width 0.3s;
`;

const ProgressPercent = styled.span`
  font-size: 1rem;
  color: #222;
  font-weight: 500;
  margin-left: 8px;
`;

const ReadDoneButton = styled.button`
  background: #244AC2;
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    background: #bbb;
    cursor: not-allowed;
  }
`;

const Desc = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 18px 12px;
  color: #555;
  font-size: 0.95rem;
  margin: 18px 0 0 0;
`;

const EditButton = styled.button`
  display: block;
  margin: 24px auto 0 auto;
  background: #898989;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
`;

const BookContainer = styled.div`
  background: #eae8e9;
  min-height: 100vh;
`;

const BookInfoContainer = styled.div`
  padding: 0 0 0 0;
  background: #eae8e9;
`;


//
const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  padding: 40px 10px 20px 10px;
`;

//
//width: 65%;
const BookInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60%;

  
 
`;

const BookTitleRow = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  margin-left: 0;
  min-width: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
`;

const BookTitleRow_bak = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-bottom: 8px;
  margin-left: 0;
  min-width: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
`;


const DdayBadge = styled.div`
  background: #636363;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  margin-left: 0;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;


//display: inline-block;
const BookTitle = styled.span`
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
`;

//display: inline-block;
const BookTitle_bak = styled.span`
  margin-left: 8px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
`;

const BookAuthor = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 4px;
  margin-left: 8px;
`;

const BookPeriod = styled.div`
  font-size: 13px;
  color: #888;
  margin-left: 7px;
  padding-bottom: 10px;
`;

const BookBadge = styled.span`
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
  justify-content: center;
`;

const ActionButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-size: 14px;
  cursor: pointer;
`;

const LoadingContainer = styled.div`
  background: #eae8e9;
  min-height: 100vh;
`;

const SkeletonBookCover = styled.div`
  width: 140px;
  height: 180px;
  border-radius: 0;
  background: #eee;
`;

const SkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

const SkeletonLine = styled.div`
  background: #eee;
  margin-bottom: ${props => props.marginBottom || '4px'};
  height: ${props => props.height || '16px'};
  width: ${props => props.width || '60%'};
`;


//left: 50%;
//  transform: translateX(-50%);
const Modal = styled.div`
  position: fixed;
  top: 0; 
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;


const BookTimerModal = ({timerBookId, onClose }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>{'독서'} 타이머</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose();}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <BookTimerPage propPageTimerType={'read'}  propBookId={timerBookId} onClose={onClose} />
      </ModalContent>
    </Modal>
  )
};


const BookRecordModal = ({bookId, onClose, onModified }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>독서 기록</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose(false);}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <BookRecordPage propBookId={bookId} onModified={onModified} />
      </ModalContent>
    </Modal>
  )
};




const BookModifyModal = ({ isbn, bookId, onClose }) => {
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>책 정보 수정</ModalTitle>
        <ModalCloseButton onClick={()=>{ if(window.confirm('수정 중인 내용이 저장되지 않습니다. 책 정보 수정을 취소하시겠습니까?')) {onClose(false);}}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        <BookRegisterPage propIsbn={isbn} propBookId={bookId} onClose={onClose} isModify={true} />
      </ModalContent>
    </Modal>
  )
};



let hrefPushed = '';
export default function BookDetailPage({propBookId = null, onClose = null, onModified = null}) {
  const navigate = useNavigate();
  const { setShowBack } = useNoobookContext();
  const { bookId:argBookId } = useParams();
  const [bookId, setBookId] = useState(propBookId ? propBookId : argBookId);
  
  const [bookData, setBookData] = useState(null);
  const [memos, setMemos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showBookModifyModal, setShowBookModifyModal] = useState(false);
  const [showBookTimerModal, setShowBookTimerModal] = useState(false);
  const [showBookRecordModal, setShowBookRecordModal] = useState(false);
  const [readDoneLoading, setReadDoneLoading] = useState(false);
  const [modified, setModified] = useState(false);

  useEffect(() => {
    setShowBack(true);
  }, []);

  useEffect(() => {
    loadBookData();
  }, [bookId]);

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showBookTimerModal) {
        event.preventDefault();
        //alert('showBookTimerModal');
        //hrefPushed = false;
        handleBookTimerClose();
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', hrefPushed);
        if(hrefPushed === window.location.href) {
          hrefPushed = null;
        }
      } else if (showBookRecordModal) {
        event.preventDefault();
        //hrefPushed = false;
        handleBookRecordClose(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', hrefPushed);
        if(hrefPushed === window.location.href) {
          hrefPushed = null;
        }
      } else if (showBookModifyModal) {
        event.preventDefault();
        //hrefPushed = false;
        handleBookModifyClose(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', hrefPushed);
        if(hrefPushed === window.location.href) {
          hrefPushed = null;
        }
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showBookTimerModal || showBookRecordModal || showBookModifyModal) {
      hrefPushed = window.location.href;
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
      return () => {
        window.removeEventListener('popstate', handlePopState);
        if(hrefPushed === window.location.href) {
          //window.history.back();
          hrefPushed = null;
        }
      };
    } 

/*
    if (showBookTimerModal || showBookRecordModal || showBookModifyModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    */
  }, [showBookTimerModal, showBookRecordModal, showBookModifyModal]);

  const loadBookData = async () => {
    if (!bookId) return;
    
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      // 책 정보 로드
      const bookResponse = await getMyBookByBookId(accessToken || '', parseInt(bookId));
      const processedBookResponse = processApiResponse(bookResponse);
      
      if (!processedBookResponse.success) {
        setError(processedBookResponse.errorMessage);
        return;
      }
      
      setBookData(processedBookResponse.data);
      
      // 메모 로드
      const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), 0, 10);
      const processedMemosResponse = processApiResponse(memosResponse);
      
      if (processedMemosResponse.success) {
        setMemos(processedMemosResponse.data || []);
      }
      
    } catch (error) {
      console.error('책 정보 로드 중 오류:', error);
      setError('네트워크 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  
  const handleTimer = () => {
    navigate(`/book-timer/read/${bookId}`);
  };

  const popupTimer = () => {
    setShowBookTimerModal(true);
  };

  const handleBookTimerClose = () => {
    setShowBookTimerModal(false);
  };
  
  /*
  const handleRecord = () => {
    navigate(`/book-record/${bookId}`);
  };*/


  const popupRecord = () => {
    setShowBookRecordModal(true);
  };

  const handleBookRecordClose = () => {
    setShowBookRecordModal(false);
    if(modified) {
      loadBookData();
      setModified(false);
    }
  };

  /*
  const handleEdit = () => {
    // 책등록 화면으로 이동
    if (bookData.isbn) {
      navigate(`/book-register?isbn=${bookData.isbn}`);
    } else {
      navigate(`/book-register?bookId=${bookId}`);
    }
  };*/


  const popupEdit = () => {
    // 책등록 화면으로 이동
    if (bookData.isbn || bookData.isbn13 || bookData.bookId) {
      setShowBookModifyModal(true);
    } 
  };

  const handleReadDone = async () => {
    if (!bookId || readDoneLoading) return;
    setReadDoneLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      const response = await putMyBookReadDone(accessToken || '', parseInt(bookId));
      const processedResponse = processApiResponse(response);
      if (processedResponse.success) {
        if (processedResponse.data) {
          setBookData(processedResponse.data);
        } else {
          await loadBookData();
        }
        if (onModified) {
          onModified(true);
        }
      } else {
        alert(processedResponse.errorMessage || '완독 처리에 실패했습니다.');
      }
    } catch (error) {
      console.error('완독 처리 중 오류:', error);
      alert('완독 처리 중 오류가 발생했습니다.');
    } finally {
      setReadDoneLoading(false);
    }
  };

  const handleBookModifyClose = (modified) => {
    setShowBookModifyModal(false);
    if(modified) {
      loadBookData();
      if(onModified) {
        onModified(true);
      }
    }
  };


  // 로딩 중이거나 에러가 있는 경우 처리
  /*
  if (loading) {
    return (
      <>
        <div style={{background:'#eae8e9', minHeight:'100vh'}}>
          <PageWrapper>
            <div style={{padding: '0 0 0 0', background: '#eae8e9'}}>
              <div style={{display: 'flex', gap: 16, padding: '40px 0 20px 20px'}}>
                <div style={{width: 140, height: 180, borderRadius: 0, background: '#eee'}}/>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1}}>
                  <div style={{width: '80%', height: 20, background: '#eee', marginBottom: 8}}/>
                  <div style={{width: '60%', height: 16, background: '#eee', marginBottom: 4}}/>
                  <div style={{width: '70%', height: 14, background: '#eee', marginBottom: 10}}/>
                  <div style={{width: '40%', height: 16, background: '#eee'}}/>
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <LoadingOverlay isLoading={loading} />
      </>
    );
  }
  */

  if (error || !bookData) {
    return (
      <ErrorContainer>
        <ErrorMessage>{error || '책 정보를 찾을 수 없습니다.'}</ErrorMessage>
      </ErrorContainer>
    );
  }

  // API 데이터를 기존 sampleBookData 형식으로 변환
  const transformedData = {
    id: bookData.id,
    title: bookData.title,
    author: bookData.author + ' / ' + bookData.publisher,
    period: stringFrDate(bookData.readFr, 'yyyy-MM-dd', '-') + ' ~ ' + stringFrDate(bookData.readTo, 'yyyy-MM-dd', '-'),
    dday: getDday(bookData.readTo),
    badge: ownership2text(bookData.ownership),
    cover: bookData.cover,
    progress: (!bookData.pageNum || bookData.pageNum == 0) ? '-' : Math.round(100 * (bookData.readPage / bookData.pageNum)),
    description: memos.length <= 0 ? '' : memos[0].memo
  };

  return (
    <>
      {/*<TopNav showBack />*/}
      
        <PageWrapper>
          <BookInfoContainer>
            <BookInfoRow>
              <BookCoverImage
                src={transformedData.cover}
                alt={transformedData.title}
              />
              <BookInfoContent>
                <BookTitleRow>
                  <DdayBadge>{transformedData.dday}</DdayBadge>
                  <BookTitle>{transformedData.title}</BookTitle>
                </BookTitleRow>
                <BookAuthor>
                  {transformedData.author}
                </BookAuthor>
                <BookPeriod>
                  {transformedData.period}
                </BookPeriod>
                <div>
                  <BookBadge>{transformedData.badge?.length > 0 ? transformedData.badge : ''}</BookBadge>
                </div>
                <ActionButtons>
                  <ActionButton onClick={popupTimer}>
                    <FaRegClock size={14} />
                    타이머
                  </ActionButton>
                  <ActionButton onClick={popupRecord}>
                    <FaRegCalendarAlt size={14} />
                    독서기록
                  </ActionButton>
                </ActionButtons>
              </BookInfoContent>
            </BookInfoRow>
          </BookInfoContainer>
          <SeparatorBar />
          <RoundedDarkBox>
            <ProgressBox>
              <ProgressLabel>
                <ProgressLabelLeft>
                  독서진행률
                  <ProgressPercent>{transformedData.progress === '-' ? '-' : transformedData.progress + '%'}</ProgressPercent>
                </ProgressLabelLeft>
                <ReadDoneButton onClick={handleReadDone} disabled={readDoneLoading}>
                  {readDoneLoading ? '처리중...' : '완독'}
                </ReadDoneButton>
              </ProgressLabel>
              <ProgressBarWrap>
                <ProgressBar percent={transformedData.progress === '-' ? 0 : transformedData.progress} />
              </ProgressBarWrap>
              <Desc>
                {transformedData.description || '아직 기록이 없습니다'}
              </Desc>
              <EditButton onClick={popupEdit}>
                독서 정보 수정
              </EditButton>
            </ProgressBox>
          </RoundedDarkBox>
        </PageWrapper>
     
      {showBookTimerModal && (
        <BookTimerModal timerBookId={bookId} onClose={handleBookTimerClose} />
      )}
      {showBookRecordModal && (
        <BookRecordModal bookId={bookId} onClose={handleBookRecordClose} onModified={()=>setModified(true)} />
      )}
      {showBookModifyModal && (
        <BookModifyModal isbn={bookData.isbn13 || bookData.isbn} bookId={bookId} onClose={handleBookModifyClose} />
      )}
      {loading && <LoadingOverlay />}
    </>
  );
} 